"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _inputRadioModule = _interopRequireDefault(require("./sass/inputRadio.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconsReact = require("@carbon/icons-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputRadio = function InputRadio(_ref) {
  var _radioInputClasses;

  var data = _ref.data,
      onChange = _ref.onChange,
      currentSelect = _ref.currentSelect,
      disabled = _ref.disabled,
      className = _ref.className;
  var radioInputClasses = (_radioInputClasses = {}, _defineProperty(_radioInputClasses, "".concat(className), className), _defineProperty(_radioInputClasses, _inputRadioModule.default.inputRadio_disabled, disabled), _radioInputClasses);
  return data.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: item.id,
      key: item.id,
      className: (0, _classnames.default)(_inputRadioModule.default.inputRadio, radioInputClasses)
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: item.name,
      id: item.id,
      value: item.value,
      onChange: onChange,
      disabled: disabled,
      className: _inputRadioModule.default.inputRadio_input
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: _inputRadioModule.default.inputRadio_checkmark
    }, item.value === currentSelect ? /*#__PURE__*/_react.default.createElement(_iconsReact.RadioButtonChecked24, {
      fill: "#008CFF"
    }) : /*#__PURE__*/_react.default.createElement(_iconsReact.RadioButton24, {
      fill: "#546982"
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: _inputRadioModule.default.inputRadio_label
    }, item.display));
  });
};

InputRadio.propTypes = {
  data: _propTypes.default.array,
  onChange: _propTypes.default.func,
  currentSelect: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
InputRadio.defaultProps = {
  data: [{
    display: 'Application or Lottery Application',
    value: 'application',
    id: 'application',
    name: 'processDigitized'
  }, {
    display: 'Enrollment Packet',
    value: 'enrollment',
    id: 'enrollment',
    name: 'processDigitized'
  }],
  onChange: null,
  currentSelect: null,
  disabled: false
};
var _default = InputRadio;
exports.default = _default;